// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5476":"91025ad6b84e01e6","6455":"3cd5e8fa0a80d2a0","7045":"0dc669a4e236a390"}[chunkId] + ".js";
};